var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"active-sequence-step-back-btn",class:[
            _vm.isInjector && 'active-sequence-step-back-btn--injector',
            _vm.isFirstStep || _vm.getActiveStep.disableBackButton ? 'disabled-step-back' : ''
        ],on:{"click":_vm.goBack}},[_vm._v(" < Шаг назад ")])}
var staticRenderFns = []

export { render, staticRenderFns }